// https://github.com/tc39/proposal-object-values-entries
var $export  = require('./_export')
  , $entries = require('./_object-to-array')(true);

$export($export.S, 'Object', {
  entries: function entries(it){
    return $entries(it);
  }
});


//////////////////
// WEBPACK FOOTER
// /data/app/rdc-next/~/core-js/modules/es7.object.entries.js
// module id = 579
// module chunks = 48 49 50 51